
import { useContext, useEffect } from "react";
import AuthContext from "../store/auth-context";
import { themeColors } from "../util/themeColors";

const ThemeHandler = () => {
    const authCtx = useContext(AuthContext);
    const themeName = authCtx.hospitalData.applicationThemeColour || "TEAL";

    useEffect(() => {
        const theme = themeColors[themeName] || themeColors.TEAL;
        const root = document.documentElement;

        root.style.setProperty("--primary-color", theme.primary);
        root.style.setProperty("--primary-hover", theme.primaryHover);
        root.style.setProperty("--secondary-color", theme.secondary);
        root.style.setProperty("--secondary-hover", theme.secondaryHover);
        root.style.setProperty("--accent-color", theme.accent);
        root.style.setProperty("--light-color", theme.light);
        root.style.setProperty("--background-color", theme.background);
        
        // Helper to convert hex to rgb for opacity based classes
        const hexToRgbValues = (hex) => {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `${r}, ${g}, ${b}`;
        };

        const rgb = hexToRgbValues(theme.primary);
        root.style.setProperty("--primary-rgb", rgb);
        root.style.setProperty("--primary-color-light", `rgba(${rgb}, 0.1)`);
        root.style.setProperty("--primary-color-shadow", `rgba(${rgb}, 0.2)`);
        root.style.setProperty("--primary-color-dark", theme.primaryHover);


        // Update body background if needed
        // document.body.style.backgroundColor = theme.background;

    }, [themeName]);

    return null;
};

export default ThemeHandler;
